import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Navbar from './components/Navbar/Navbar';
import PaymentDashboard from './components/PaymentDashboard/PaymentDashboard';
import AddOrRemoveUser from './components/AddOrRemoveUsers/AddOrRemoveUser';
import PurchaseHistory from './components/TransactionHistory/PurchaseHistory';
import TransferHistory from './components/TransactionHistory/TransferHistory';
import ActionLogs from './components/Logs/ActionLogs';
import { useAuth } from './context/AuthContext';
import './globalStyles.css';

function App() {
  const { isLoggedIn } = useAuth();

  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Navigate to="/payments" replace />} />
        <Route path="/payments" element={<PaymentDashboard />} />
        <Route path="/addOrRemoveUsers" element={<AddOrRemoveUser />} />
        <Route path="/purchases" element={<PurchaseHistory />} />
        <Route path="/transfers" element={<TransferHistory />} />
        <Route
          path="/logs"
          element={isLoggedIn ? <ActionLogs /> : <Navigate to="/payments" replace />}
        />
      </Routes>
    </>
  );
}

export default App;
